"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JstObject = undefined;
var _assign = require("babel-runtime/core-js/object/assign");
var _assign2 = _interopRequireDefault(_assign);
var _set = require("babel-runtime/core-js/set");
var _set2 = _interopRequireDefault(_set);
var _typeof2 = require("babel-runtime/helpers/typeof");
var _typeof3 = _interopRequireDefault(_typeof2);
var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");
var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
var _keys = require("babel-runtime/core-js/object/keys");
var _keys2 = _interopRequireDefault(_keys);
var _getIterator2 = require("babel-runtime/core-js/get-iterator");
var _getIterator3 = _interopRequireDefault(_getIterator2);
var _values = require("babel-runtime/core-js/object/values");
var _values2 = _interopRequireDefault(_values);
var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require("babel-runtime/helpers/inherits");
var _inherits3 = _interopRequireDefault(_inherits2);
var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require("babel-runtime/helpers/createClass");
var _createClass3 = _interopRequireDefault(_createClass2);
exports.jst = jst;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function jst(selectorOrElement) {
  if (selectorOrElement instanceof HTMLElement) {
    return new JstElement(selectorOrElement);
  } else {
    var el = document.querySelector(selectorOrElement);
    if (!el) {
      return new JstElement();
    } else {
      return new JstElement(el);
    }
  }
}
exports.default = jst;
var globalJstObjectId = 1;
var globalJstObjectClassId = 1;
var globalJstElementId = 1;
var JstObject = exports.JstObject = function () {
  function JstObject(companionObj) {
    (0, _classCallCheck3.default)(this, JstObject);
    this._jstId = globalJstObjectId++;
    this._companionObj = companionObj;
    this._renderFunc = undefined;
    this._forms = {};
    this._wasRendered = false;
    this._jstEl = undefined;
    this._refCount = 0;
    this.updateWithParent = false;
    if (!this.constructor.prototype._jstClassId) {
      this.constructor.prototype._jstClassId = globalJstObjectClassId++;
    }
    this._classPrefix = "jsto" + this._jstClassId + "-";
    this._fullPrefix = "jsto" + this._jstClassId + "-i" + this._jstId + "-";
    this._type = this.getName() + "-" + this.getFullPrefix();
  }
  (0, _createClass3.default)(JstObject, [{
    key: "destroy",
    value: function destroy() {
      jst.styleManager.removeCss(this);
    }
  }, {
    key: "refresh",
    value: function refresh(opts) {
      var isParentUpdate = opts ? opts.isParentUpdate : false;
      if (!isParentUpdate && !this._jstEl) {
        return;
      }
      var css = this.renderCss(opts);
      if (css) {
        jst.styleManager.updateCss(this, css);
      }
      this._refCount++;
      if (!this._jstEl && isParentUpdate || isParentUpdate && this.updateWithParent || !isParentUpdate) {
        var items = this._render();
        var newJst = new JstElement("jstobject", [{
          type: this.getType()
        }]);
        newJst._processParams([items], true);
        if (this._jstEl) {
          this._jstEl._compareAndCopy(newJst, true, this, false, 0);
          this._unrender();
        } else {
          this._jstEl = newJst;
        }
        if (this._jstEl.isDomified) {
          this._jstEl.dom(this);
        }
      }
    }
  }, {
    key: "_render",
    value: function _render() {
      var items = this.render();
      this._wasRendered = true;
      return items;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this._renderFunc) {
        if (this._companionObj) {
          throw new Error("You must define a render function with .fill()");
        } else {
          throw new Error("You must override render() in descendant classes");
        }
      } else {
        return this._renderFunc(this._companionObj);
      }
    }
  }, {
    key: "_unrender",
    value: function _unrender() {
      this._refCount--;
      if (this._refCount < 0) {
        throw new Error("Invalid ref count in jstobject", this);
      }
      if (this._refCount == 0) {
        this.unrender();
        if (this._jstEl) {
          this._jstEl.delete();
          delete this._jstEl;
        }
        this.destroy();
      }
    }
  }, {
    key: "unrender",
    value: function unrender() {}
  }, {
    key: "renderCss",
    value: function renderCss() {
      var css = {};
      var someCss = false;
      var _arr = ["cssGlobal", "cssLocal", "cssInstance"];
      for (var _i = 0; _i < _arr.length; _i++) {
        var type = _arr[_i];
        if (this[type]) {
          var rawCss = this[type]();
          if (rawCss) {
            css[type] = jst._normalizeCss(rawCss);
            someCss = true;
          }
        }
      }
      return someCss ? css : undefined;
    }
  }, {
    key: "getWasRendered",
    value: function getWasRendered() {
      return this._wasRendered;
    }
  }, {
    key: "getClassPrefix",
    value: function getClassPrefix() {
      return this._classPrefix;
    }
  }, {
    key: "getFullPrefix",
    value: function getFullPrefix() {
      return this._fullPrefix;
    }
  }, {
    key: "getUpdateWithParent",
    value: function getUpdateWithParent() {
      return this.updateWithParent;
    }
  }, {
    key: "fill",
    value: function fill(renderFunc) {
      if (typeof renderFunc !== "function") {
        throw new Error(".fill() expects a function to be passed in");
      }
      this._renderFunc = renderFunc;
      return this;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.constructor.name;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this._type;
    }
  }, {
    key: "addForm",
    value: function addForm(jstElement) {
      var name = jstElement.attrs.name || jstElement.attrs.id || "_unnamed_";
      if (this._forms[name]) {
        this._forms[name].setJstElement(jstElement);
      } else {
        this._forms[name] = new JstForm(jstElement);
      }
      return this._forms[name];
    }
  }, {
    key: "getFormValues",
    value: function getFormValues(name) {
      var form = this._forms[name || "_unnamed_"];
      return form ? form.getValues() : {};
    }
  }, {
    key: "setRef",
    value: function setRef(refName, val) {
      if (this._companionObj) {
        this._companionObj[refName] = val;
      } else {
        this[refName] = val;
      }
    }
  }, {
    key: "_getCodeLocation",
    value: function _getCodeLocation() {}
  }]);
  return JstObject;
}();
var JstStyle = function (_JstObject) {
  (0, _inherits3.default)(JstStyle, _JstObject);
  function JstStyle(classPrefix, className) {
    (0, _classCallCheck3.default)(this, JstStyle);
    var _this = (0, _possibleConstructorReturn3.default)(this, (JstStyle.__proto__ || (0, _getPrototypeOf2.default)(JstStyle)).call(this));
    _this.classPrefix = classPrefix;
    _this.className = className;
    _this.css = {
      cssGlobal: [],
      cssLocal: [],
      cssInstance: {}
    };
    return _this;
  }
  (0, _createClass3.default)(JstStyle, [{
    key: "updateCss",
    value: function updateCss(fullPrefix, css) {
      var processedCss = this._processCss(fullPrefix, css);
      this.css.cssGlobal = processedCss.cssGlobal;
      this.css.cssLocal = processedCss.cssLocal;
      if (!this.css.cssInstance) {
        this.css.cssInstance = {};
      }
      this.css.cssInstance[fullPrefix] = processedCss.cssInstance;
      this.refresh();
    }
  }, {
    key: "removeCss",
    value: function removeCss(fullPrefix) {
      if (this.css.cssInstance[fullPrefix]) {
        delete this.css.cssInstance[fullPrefix];
        this.refresh();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return ["cssGlobal", "cssLocal", "cssInstance"].map(function (type) {
        if (_this2.css && _this2.css[type]) {
          if (type === "cssInstance") {
            return (0, _values2.default)(_this2.css.cssInstance).map(function (instance) {
              return instance.map(function (item) {
                return jst.$style(item);
              });
            });
          } else {
            return _this2.css[type].map(function (item) {
              return jst.$style(item);
            });
          }
        }
        return undefined;
      });
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.getName() + "-" + this.className;
    }
  }, {
    key: "_processCss",
    value: function _processCss(fullPrefix, css) {
      var processedCss = {};
      var _arr2 = [["cssGlobal"], ["cssLocal", this.classPrefix], ["cssInstance", fullPrefix]];
      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var typeInfo = _arr2[_i2];
        var type = typeInfo[0];
        var prefix = typeInfo[1];
        processedCss[type] = [];
        if (css[type]) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;
          try {
            for (var _iterator = (0, _getIterator3.default)(css[type]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var block = _step.value;
              processedCss[type].push(this._stringify(prefix, block));
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      }
      return processedCss;
    }
  }, {
    key: "_stringify",
    value: function _stringify(prefix, block) {
      var text = "";
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;
      try {
        for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(block)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var selector = _step2.value;
          var atRuleRule = void 0;
          if (selector.match(/^@/)) {
            atRuleRule = block[selector][":rule"];
            console.log("Got at rule", selector, atRuleRule, block);
            delete block[selector][":rule"];
          }
          var rules = block[selector];
          if (typeof atRuleRule != "undefined") {
            text += selector + " " + atRuleRule + " {\n";
            text += this._stringify(prefix, rules);
            text += "}\n";
          } else {
            var scopedSelector = prefix ? selector.replace(/([\.#])/g, "$1" + prefix) : selector;
            text += scopedSelector + " ";
            text += this._stringifyObj(rules, "");
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
      return text;
    }
  }, {
    key: "_stringifyObj",
    value: function _stringifyObj(obj, indent) {
      var _this3 = this;
      if (!(obj instanceof Object)) {
        return obj.toString();
      }
      var text = "{\n";
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;
      try {
        for (var _iterator3 = (0, _getIterator3.default)((0, _keys2.default)(obj)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var prop = _step3.value;
          var val = obj[prop];
          var attr = prop.replace(/([A-Z])/g, function (m) {
            return "-" + m.toLowerCase();
          });
          val = val.reduce ? val.reduce(function (acc, item) {
            return acc + " " + _this3._stringifyObj(item, indent + "  ");
          }, "") : val.toString();
          val = val.replace(/\s+/, " ");
          if (val.substr(-2, 1) !== "}") {
            text += indent + "  " + attr + ": " + val + ";\n";
          } else {
            text += indent + "  " + attr + " " + val;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
      text += indent + "}\n";
      return text;
    }
  }]);
  return JstStyle;
}(JstObject);
var JstStyleManager = function (_JstObject2) {
  (0, _inherits3.default)(JstStyleManager, _JstObject2);
  function JstStyleManager() {
    (0, _classCallCheck3.default)(this, JstStyleManager);
    var _this4 = (0, _possibleConstructorReturn3.default)(this, (JstStyleManager.__proto__ || (0, _getPrototypeOf2.default)(JstStyleManager)).call(this));
    _this4.jstStyleLookup = {};
    _this4.jstStyles = [];
    return _this4;
  }
  (0, _createClass3.default)(JstStyleManager, [{
    key: "render",
    value: function render() {
      return this.jstStyles;
    }
  }, {
    key: "updateCss",
    value: function updateCss(jstObj, css) {
      var classPrefix = jstObj.getClassPrefix();
      var fullPrefix = jstObj.getFullPrefix();
      var jstStyle = this.jstStyleLookup[classPrefix];
      var madeNew = false;
      if (!jstStyle) {
        jstStyle = new JstStyle(classPrefix, jstObj.getName());
        madeNew = true;
      }
      jstStyle.updateCss(fullPrefix, css);
      if (madeNew) {
        this._addStyle(jstStyle, classPrefix);
      } else {
        jstStyle.refresh();
      }
    }
  }, {
    key: "removeCss",
    value: function removeCss(jstObj) {
      var classPrefix = jstObj.getClassPrefix();
      var fullPrefix = jstObj.getFullPrefix();
      var jstStyle = this.jstStyleLookup[classPrefix];
      if (jstStyle) {
        jstStyle.removeCss(fullPrefix);
        this._removeStyle(jstStyle, classPrefix);
      }
    }
  }, {
    key: "_addStyle",
    value: function _addStyle(jstStyle, classPrefix) {
      this.jstStyles.push(jstStyle);
      this.jstStyleLookup[classPrefix] = jstStyle;
      this.refresh();
    }
  }, {
    key: "_removeStyle",
    value: function _removeStyle(jstStyle, classPrefix) {
      return;
      var index = 0;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;
      try {
        for (var _iterator4 = (0, _getIterator3.default)(this.jstStyles), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var entry = _step4.value;
          if (jstStyle === entry) {
            this.jstStyles.splice(index, 1);
            delete this.jstStyleLookup[classPrefix];
            break;
          }
          index++;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
      this.refresh();
    }
  }]);
  return JstStyleManager;
}(JstObject);
var JstForm = function () {
  function JstForm(jstElement) {
    (0, _classCallCheck3.default)(this, JstForm);
    this.jstElement = jstElement;
    this.inputs = {};
  }
  (0, _createClass3.default)(JstForm, [{
    key: "addInput",
    value: function addInput(jstElement) {
      var name = jstElement.attrs.name || jstElement.attrs.id;
      if (name) {
        if (this.inputs[name]) {
          if (Array.isArray(this.inputs[name])) {
            this.inputs[name].push(jstElement);
          } else {
            this.inputs[name] = [this.inputs[name], jstElement];
          }
        } else {
          this.inputs[name] = jstElement;
        }
      }
    }
  }, {
    key: "setJstElement",
    value: function setJstElement(jstElement) {
      this.jstElement = jstElement;
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var vals = {};
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;
      try {
        for (var _iterator5 = (0, _getIterator3.default)((0, _keys2.default)(this.inputs)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var name = _step5.value;
          if (Array.isArray(this.inputs[name])) {
            if (this.inputs[name][0].attrs.type && this.inputs[name][0].attrs.type.toLowerCase() === "radio") {
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;
              try {
                for (var _iterator6 = (0, _getIterator3.default)(this.inputs[name]), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var input = _step6.value;
                  if (input.el.checked) {
                    vals[name] = input.attrs.value || input.attrs.id;
                  }
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            } else if (this.inputs[name][0].attrs.type && this.inputs[name][0].attrs.type.toLowerCase() === "checkbox") {
              vals[name] = [];
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;
              try {
                for (var _iterator7 = (0, _getIterator3.default)(this.inputs[name]), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var _input = _step7.value;
                  if (_input.el.checked) {
                    vals[name].push(_input.attrs.value || _input.attrs.id);
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            } else {
              vals[name] = this.inputs[name][0].el.value;
            }
          } else {
            vals[name] = this.inputs[name].el.value;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
      return vals;
    }
  }]);
  return JstForm;
}();
var JstElement = function () {
  function JstElement(tag, params) {
    (0, _classCallCheck3.default)(this, JstElement);
    this.id = globalJstElementId++;
    this.contents = [];
    this.attrs = {};
    this.props = [];
    this.events = {};
    this.opts = {};
    if (tag instanceof HTMLElement) {
      this.tag = tag.tagName.toLowerCase();
      this.el = tag;
    } else {
      this.tag = tag.toLowerCase();
    }
    this._processParams(params);
    if (this.el) {
      this.dom();
    }
  }
  (0, _createClass3.default)(JstElement, [{
    key: "appendChild",
    value: function appendChild() {
      this.isDomified = false;
      this._processParams(arguments);
      if (this.el) {
        this.dom();
      }
    }
  }, {
    key: "replaceChild",
    value: function replaceChild() {
      if (this.el) {
        this.el.innerHTML = "";
      }
      this.isDomified = false;
      this.contents = [];
      this.atts = [];
      this.props = [];
      this.appendChild.apply(this, arguments);
    }
  }, {
    key: "html",
    value: function html(opts) {
      var html = "";
      if (!opts) {
        opts = {};
      }
      if (!opts.depth) {
        opts.depth = 0;
      }
      if (opts.indent) {
        html += " ".repeat(opts.indent * opts.depth++);
      }
      html += "<" + this.tag;
      var attrs = [];
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;
      try {
        for (var _iterator8 = (0, _getIterator3.default)((0, _keys2.default)(this.attrs)), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var attrName = _step8.value;
          attrs.push(attrName + "=" + "\"" + this._quoteAttrValue(this.attrs[attrName]) + "\"");
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
      if (attrs.length) {
        html += " " + attrs.join(" ");
      }
      if (this.props.length) {
        html += " " + this.props.join(" ");
      }
      html += ">";
      if (opts.indent) {
        html += "\n";
      }
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;
      try {
        for (var _iterator9 = (0, _getIterator3.default)(this.contents), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var item = _step9.value;
          if (item.type === "jst") {
            html += item.value.html(opts);
          } else if (item.type === "obj" && item.value._jstEl) {
            html += item.value._jstEl.html(opts);
          } else if (item.type === "HTMLElement") {
            html += item.value.innerHTML;
          } else if (item.type === "textnode") {
            if (opts.indent && opts.depth) {
              html += " ".repeat(opts.indent * opts.depth);
            }
            html += item.value;
            if (opts.indent && opts.depth) {
              html += "\n";
            }
          } else {
            console.warn("Unexpected content type while serializing:", item.type);
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
      if (opts.indent && opts.depth) {
        opts.depth--;
        html += " ".repeat(opts.indent * opts.depth);
      }
      html += "</" + this.tag + ">";
      if (opts.indent) {
        html += "\n";
      }
      return html;
    }
  }, {
    key: "dom",
    value: function dom(lastJstObject, lastJstForm) {
      var el = this.el || document.createElement(this.tag);
      if (this.ref && lastJstObject) {
        lastJstObject.setRef(this.ref, this);
      }
      if (lastJstObject && this.tag === "form" && (this.attrs.name || this.attrs.id)) {
        lastJstForm = lastJstObject.addForm(this);
      } else if (lastJstForm && (this.tag === "input" || this.tag === "textarea" || this.tag === "select")) {
        lastJstForm.addInput(this);
      }
      if (!this.isDomified) {
        this.jstObject = lastJstObject;
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;
        try {
          for (var _iterator10 = (0, _getIterator3.default)((0, _keys2.default)(this.attrs)), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var attrName = _step10.value;
            var val = this.attrs[attrName];
            if (lastJstObject && (attrName === "class" || attrName === "id") && val.match && val.match(/(^|\s)-/)) {
              val = val.replace(/(^|\s)(--?)/g, function (m, p1, p2) {
                return p1 + (p2 === "-" ? lastJstObject.getClassPrefix() : lastJstObject.getFullPrefix());
              });
            }
            el.setAttribute(attrName, val);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;
        try {
          for (var _iterator11 = (0, _getIterator3.default)(this.props), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var propName = _step11.value;
            el[propName] = true;
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;
        try {
          for (var _iterator12 = (0, _getIterator3.default)((0, _keys2.default)(this.events)), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var event = _step12.value;
            el.addEventListener(event, this.events[event].listener);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }
      }
      var nextEl = void 0;
      var contentsStack = [];
      var index = this.contents.length - 1;
      var contents = this.contents;
      var sanity = 100000000;
      if (index >= 0) {
        while (sanity--) {
          var item = contents[index];
          if (item.type === "jst" || item.type === "obj") {
            if (0 && !jst.debug && item.type && item.value._jstEl && item.value._jstEl.contents.length) {
              if (index) {
                contentsStack.push([index - 1, contents, lastJstObject]);
              }
              contents = item.value._jstEl.contents;
              index = contents.length - 1;
              lastJstObject = item.value;
              continue;
            } else if (item.type === "obj") {
              lastJstObject = item.value;
              if (item.value._jstEl) {
                item = {
                  value: item.value._jstEl,
                  type: "jst"
                };
              }
            }
            var hasEl = item.value.el;
            var childEl = item.value.dom(lastJstObject, lastJstForm);
            if (!hasEl) {
              if (nextEl) {
                el.insertBefore(childEl, nextEl);
              } else {
                el.appendChild(childEl);
              }
            }
            nextEl = childEl;
          } else if (item.type === "textnode") {
            if (!item.el) {
              item.el = document.createTextNode(item.value);
              if (nextEl) {
                el.insertBefore(item.el, nextEl);
              } else {
                el.appendChild(item.el);
              }
            }
          } else {
            console.warn("Unexpected content type while dominating:", item.type);
          }
          if (!index) {
            if (contentsStack.length) {
              var stackItem = contentsStack.pop();
              index = stackItem[0];
              contents = stackItem[1];
              lastJstObject = stackItem[2];
            } else {
              break;
            }
          } else {
            index--;
          }
        }
      }
      this.el = el;
      this.isDomified = true;
      return el;
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;
      try {
        for (var _iterator13 = (0, _getIterator3.default)(this.contents), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var item = _step13.value;
          this._deleteItem(item);
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }
      delete this.jstObject;
      if (this.el) {
        if (this.el.parentNode) {
          this.el.parentNode.removeChild(this.el);
        }
      }
      delete this.el;
      this.tag = "-deleted-";
      this.contents = [];
      this.attrs = {};
      this.props = [];
    }
  }, {
    key: "_compareAndCopy",
    value: function _compareAndCopy(newJst, topNode, jstObject, forceUpdate, level) {
      var _this5 = this;
      var oldIndex = 0;
      var newIndex = 0;
      if (!topNode) {
        if (forceUpdate || this.opts.forceUpdate || this.tag !== newJst.tag) {
          return true;
        }
        this.opts = newJst.opts;
        var _iteratorNormalCompletion14 = true;
        var _didIteratorError14 = false;
        var _iteratorError14 = undefined;
        try {
          for (var _iterator14 = (0, _getIterator3.default)((0, _keys2.default)(this.attrs)), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
            var attrName = _step14.value;
            if (!newJst.attrs[attrName]) {
              delete this.attrs[attrName];
              if (this.isDomified) {
                this.el.removeAttribute(attrName);
              }
            } else if (newJst.attrs[attrName] !== this.attrs[attrName]) {
              this.attrs[attrName] = newJst.attrs[attrName];
              if (this.isDomified) {
                var val = newJst.attrs[attrName];
                if (this.jstObject && (attrName === "class" || attrName === "id") && val.match(/(^|\s)-/)) {
                  val = val.replace(/(^|\s)(--?)/g, function (m, p1, p2) {
                    return p1 + (p2 === "-" ? _this5.jstObject.getClassPrefix() : _this5.jstObject.getFullPrefix());
                  });
                }
                this.el.setAttribute(attrName, val);
              }
            }
          }
        } catch (err) {
          _didIteratorError14 = true;
          _iteratorError14 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion14 && _iterator14.return) {
              _iterator14.return();
            }
          } finally {
            if (_didIteratorError14) {
              throw _iteratorError14;
            }
          }
        }
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;
        try {
          for (var _iterator15 = (0, _getIterator3.default)((0, _keys2.default)(newJst.attrs)), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            var _attrName = _step15.value;
            if (!this.attrs[_attrName]) {
              this.attrs[_attrName] = newJst.attrs[_attrName];
              if (this.isDomified) {
                var _val = newJst.attrs[_attrName];
                if (this.jstObject && (_attrName === "class" || _attrName === "id") && _val.match(/(^|\s)-/)) {
                  _val = _val.replace(/(^|\s)(--?)/g, function (m, p1, p2) {
                    return p1 + (p2 === "-" ? _this5.jstObject.getClassPrefix() : _this5.jstObject.getFullPrefix());
                  });
                }
                this.el.setAttribute(_attrName, _val);
              }
            }
          }
        } catch (err) {
          _didIteratorError15 = true;
          _iteratorError15 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion15 && _iterator15.return) {
              _iterator15.return();
            }
          } finally {
            if (_didIteratorError15) {
              throw _iteratorError15;
            }
          }
        }
        if (this.props.length || newJst.props.length) {
          var fixProps = false;
          if (this.props.length != newJst.props.length) {
            fixProps = true;
          } else {
            for (var i = 0; i < this.props.length; i++) {
              if (this.props[i] !== newJst.props[i]) {
                fixProps = true;
                break;
              }
            }
          }
          if (fixProps) {
            if (this.isDomified) {
              var _iteratorNormalCompletion16 = true;
              var _didIteratorError16 = false;
              var _iteratorError16 = undefined;
              try {
                for (var _iterator16 = (0, _getIterator3.default)(this.props), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                  var prop = _step16.value;
                  delete this.el[prop];
                }
              } catch (err) {
                _didIteratorError16 = true;
                _iteratorError16 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion16 && _iterator16.return) {
                    _iterator16.return();
                  }
                } finally {
                  if (_didIteratorError16) {
                    throw _iteratorError16;
                  }
                }
              }
              var _iteratorNormalCompletion17 = true;
              var _didIteratorError17 = false;
              var _iteratorError17 = undefined;
              try {
                for (var _iterator17 = (0, _getIterator3.default)(newJst.props), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                  var _prop = _step17.value;
                  this.el[_prop] = true;
                }
              } catch (err) {
                _didIteratorError17 = true;
                _iteratorError17 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion17 && _iterator17.return) {
                    _iterator17.return();
                  }
                } finally {
                  if (_didIteratorError17) {
                    throw _iteratorError17;
                  }
                }
              }
            }
            this.props = newJst.props;
          }
        }
        var _iteratorNormalCompletion18 = true;
        var _didIteratorError18 = false;
        var _iteratorError18 = undefined;
        try {
          for (var _iterator18 = (0, _getIterator3.default)((0, _keys2.default)(this.events)), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
            var eventName = _step18.value;
            if (!newJst.events[eventName]) {
              if (this.isDomified) {
                this.el.removeEventListener(eventName, this.events[eventName].listener);
              }
              delete this.events[eventName];
            } else if (newJst.events[eventName].listener !== this.events[eventName].listener) {
              if (this.isDomified) {
                this.el.removeEventListener(eventName, this.events[eventName].listener);
                this.el.addEventListener(eventName, newJst.events[eventName].listener);
              }
              this.events[eventName] = newJst.events[eventName];
            }
          }
        } catch (err) {
          _didIteratorError18 = true;
          _iteratorError18 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion18 && _iterator18.return) {
              _iterator18.return();
            }
          } finally {
            if (_didIteratorError18) {
              throw _iteratorError18;
            }
          }
        }
        var _iteratorNormalCompletion19 = true;
        var _didIteratorError19 = false;
        var _iteratorError19 = undefined;
        try {
          for (var _iterator19 = (0, _getIterator3.default)((0, _keys2.default)(newJst.events)), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
            var _eventName = _step19.value;
            if (!this.events[_eventName]) {
              this.events[_eventName] = newJst.events[_eventName];
              if (this.isDomified) {
                this.el.addEventListener(_eventName, newJst.events[_eventName].listener);
              }
            }
          }
        } catch (err) {
          _didIteratorError19 = true;
          _iteratorError19 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion19 && _iterator19.return) {
              _iterator19.return();
            }
          } finally {
            if (_didIteratorError19) {
              throw _iteratorError19;
            }
          }
        }
      }
      if (!forceUpdate && !this.opts.forceUpdate) {
        while (true) {
          var _oldItem = this.contents[oldIndex];
          var newItem = newJst.contents[newIndex];
          if (!_oldItem || !newItem) {
            break;
          }
          if (_oldItem.type !== newItem.type) {
            break;
          }
          if (_oldItem.type === "jst") {
            var doReplace = _oldItem.value._compareAndCopy(newItem.value, false, undefined, undefined, level + 1);
            if (doReplace) {
              break;
            }
          } else if (_oldItem.type === "obj") {
            if (_oldItem.value._jstId != newItem.value._jstId) {
              break;
            }
          } else if (_oldItem.type === "textnode" && _oldItem.value !== newItem.value) {
            if (_oldItem.el) {
              _oldItem.el.textContent = newItem.value;
            }
            _oldItem.value = newItem.value;
          }
          oldIndex++;
          newIndex++;
          if (newItem.type === "obj") {
            newItem.value._unrender();
          }
        }
      }
      var oldStartIndex = oldIndex;
      var oldItem = this.contents[oldIndex];
      var itemsToDelete = [];
      while (oldItem) {
        itemsToDelete.push(oldItem);
        oldIndex++;
        oldItem = this.contents[oldIndex];
      }
      this.contents.splice(oldStartIndex, oldIndex - oldStartIndex);
      if (newJst.contents[newIndex]) {
        var _contents;
        var newItems = newJst.contents.splice(newIndex, newJst.contents.length - newIndex);
        (_contents = this.contents).splice.apply(_contents, [oldStartIndex, 0].concat((0, _toConsumableArray3.default)(newItems)));
      }
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;
      try {
        for (var _iterator20 = (0, _getIterator3.default)(itemsToDelete), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var itemToDelete = _step20.value;
          this._deleteItem(itemToDelete);
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }
      return false;
    }
  }, {
    key: "_deleteItem",
    value: function _deleteItem(contentsItem) {
      if (contentsItem.type === "jst") {
        contentsItem.value.delete();
      } else if (contentsItem.type === "obj") {
        contentsItem.value._unrender();
      } else if (contentsItem.type === "textnode") {
        if (contentsItem.el && contentsItem.el.parentNode) {
          contentsItem.el.parentNode.removeChild(contentsItem.el);
          delete contentsItem.el;
        }
      } else {
        console.warn("Unexpected content type while deleting:", contentsItem.type);
      }
    }
  }, {
    key: "_processParams",
    value: function _processParams(params, isUpdate) {
      params = jst._flatten.apply(this, params);
      if (typeof params === "undefined") {
        params = [];
      }
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;
      try {
        for (var _iterator21 = (0, _getIterator3.default)(params), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var param = _step21.value;
          var type = typeof param === "undefined" ? "undefined" : (0, _typeof3.default)(param);
          if (type === "number" || type === "string") {
            this.contents.push({
              type: "textnode",
              value: param
            });
          } else if (type === "boolean") {
            this.contents.push({
              type: "textnode",
              value: param.toString()
            });
          } else if (param instanceof JstObject) {
            this.contents.push({
              type: "obj",
              value: param
            });
            param.refresh({
              isParentUpdate: true
            });
          } else if (param instanceof JstElement) {
            this.contents.push({
              type: "jst",
              value: param
            });
          } else if (typeof HTMLElement !== "undefined" && param instanceof HTMLElement) {
            this.contents.push({
              type: "jst",
              value: new JstElement(param)
            });
          } else if (type === "object") {
            var _iteratorNormalCompletion22 = true;
            var _didIteratorError22 = false;
            var _iteratorError22 = undefined;
            try {
              for (var _iterator22 = (0, _getIterator3.default)((0, _keys2.default)(param)), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                var name = _step22.value;
                if (typeof param[name] === "undefined") {
                  param[name] = "";
                }
                if (name === "jstoptions" && param.jstoptions instanceof Object) {
                  this.opts = param.jstoptions;
                } else if (name === "properties" && param.properties instanceof Array) {
                  var _iteratorNormalCompletion23 = true;
                  var _didIteratorError23 = false;
                  var _iteratorError23 = undefined;
                  try {
                    for (var _iterator23 = (0, _getIterator3.default)(param.properties), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                      var prop = _step23.value;
                      this.props.push(prop);
                    }
                  } catch (err) {
                    _didIteratorError23 = true;
                    _iteratorError23 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion23 && _iterator23.return) {
                        _iterator23.return();
                      }
                    } finally {
                      if (_didIteratorError23) {
                        throw _iteratorError23;
                      }
                    }
                  }
                } else if (name === "events" && (0, _typeof3.default)(param.events) === "object") {
                  var _iteratorNormalCompletion24 = true;
                  var _didIteratorError24 = false;
                  var _iteratorError24 = undefined;
                  try {
                    for (var _iterator24 = (0, _getIterator3.default)((0, _keys2.default)(param.events)), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                      var event = _step24.value;
                      if (param.events[event] instanceof Function) {
                        this.events[event] = {
                          listener: param.events[event]
                        };
                      } else {
                        this.events[event] = param.events[event];
                      }
                    }
                  } catch (err) {
                    _didIteratorError24 = true;
                    _iteratorError24 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion24 && _iterator24.return) {
                        _iterator24.return();
                      }
                    } finally {
                      if (_didIteratorError24) {
                        throw _iteratorError24;
                      }
                    }
                  }
                } else if (name === "ref") {
                  this.ref = param[name];
                  this.attrs.ref = param[name];
                } else if (name === "cn") {
                  if (this.attrs["class"]) {
                    this.attrs["class"] += " " + param[name];
                  } else {
                    this.attrs["class"] = param[name];
                  }
                } else if (param[name] !== "") {
                  this.attrs[name] = param[name];
                }
              }
            } catch (err) {
              _didIteratorError22 = true;
              _iteratorError22 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion22 && _iterator22.return) {
                  _iterator22.return();
                }
              } finally {
                if (_didIteratorError22) {
                  throw _iteratorError22;
                }
              }
            }
          } else if (type === "undefined") {} else if (param.toString) {
            this.contents.push({
              type: "textnode",
              value: param.toString()
            });
          } else {
            console.warn("Unknown JstElement parameter type: ", type);
          }
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }
    }
  }, {
    key: "_processCss",
    value: function _processCss(jstObj, css) {
      if (css) {
        jst.styleManager.updateCss(jstObj, css);
      }
    }
  }, {
    key: "_quoteAttrValue",
    value: function _quoteAttrValue(value) {
      return value.replace ? value.replace(/"/, "\"") : value;
    }
  }]);
  return JstElement;
}();
jst.fn = jst.prototype = {};
jst.extend = jst.fn.extend = function () {
  var target = this;
  var length = arguments.length;
  for (var i = 0; i < length; i++) {
    var options = void 0;
    if ((options = arguments[i]) !== null) {
      for (var name in options) {
        var copy = options[name];
        if (target === copy) {
          continue;
        }
        if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
};
jst.extend({
  debug: true,
  tagPrefix: "$",
  Object: JstObject,
  Form: JstForm,
  Element: JstElement,
  tags: ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "command", "data", "datalist", "dd", "del", "details", "dfn", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "discard", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignObject", "g", "glyph", "glyphRef", "hatch", "hatchpath", "hkern", "image", "line", "linearGradient", "marker", "mask", "mesh", "meshgradient", "meshpatch", "meshrow", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "solidcolor", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "unknown", "use", "view", "vkern"],
  cssFuncs: ["attr", "calc", "cubic-bezier", "hsl", "hsla", "linear-gradient", "radial-gradient", "repeating-linear-gradient", "repeating-radial-gradient", "rgb", "rgba", "var", "translate", "matrix", "matrix3d", "translate", "translate3d", "translateX", "translateY", "translateZ", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "rotate", "rotate3d", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY", "perspective"],
  cssUnits: ["cm", "mm", "in", "px", "pt", "pc", "em", "ex", "ch", "rem", "vw", "vh", "vmin", "vmax", "deg", "rad", "s"],
  addCustomElements: function addCustomElements() {
    var names = jst._flatten.apply(this, arguments);
    var _iteratorNormalCompletion25 = true;
    var _didIteratorError25 = false;
    var _iteratorError25 = undefined;
    try {
      var _loop = function _loop() {
        var name = _step25.value;
        var fullName = jst.tagPrefix + name;
        jst[fullName] = function () {
          var args = jst._flatten.apply(this, arguments);
          return new JstElement(name, args);
        };
      };
      for (var _iterator25 = (0, _getIterator3.default)(names), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError25 = true;
      _iteratorError25 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion25 && _iterator25.return) {
          _iterator25.return();
        }
      } finally {
        if (_didIteratorError25) {
          throw _iteratorError25;
        }
      }
    }
  },
  addCssFunctions: function addCssFunctions() {
    var names = jst._flatten.apply(this, arguments);
    var _iteratorNormalCompletion26 = true;
    var _didIteratorError26 = false;
    var _iteratorError26 = undefined;
    try {
      var _loop2 = function _loop2() {
        var name = _step26.value;
        var camelName = name.replace(/-([a-z])/g, function (match) {
          return match[1].toUpperCase();
        });
        jst[camelName] = function () {
          var args = jst._flatten.apply(this, arguments);
          return name + "(" + args.join(",") + ")";
        };
      };
      for (var _iterator26 = (0, _getIterator3.default)(names), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
        _loop2();
      }
    } catch (err) {
      _didIteratorError26 = true;
      _iteratorError26 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion26 && _iterator26.return) {
          _iterator26.return();
        }
      } finally {
        if (_didIteratorError26) {
          throw _iteratorError26;
        }
      }
    }
  },
  addCssUnits: function addCssUnits() {
    var names = jst._flatten.apply(this, arguments);
    var _iteratorNormalCompletion27 = true;
    var _didIteratorError27 = false;
    var _iteratorError27 = undefined;
    try {
      var _loop3 = function _loop3() {
        var name = _step27.value;
        jst[name] = function () {
          var args = jst._flatten.apply(this, arguments);
          var fixed = args.map(function (arg) {
            return "" + arg + name;
          });
          return fixed.join(" ") + " ";
        };
      };
      for (var _iterator27 = (0, _getIterator3.default)(names), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
        _loop3();
      }
    } catch (err) {
      _didIteratorError27 = true;
      _iteratorError27 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion27 && _iterator27.return) {
          _iterator27.return();
        }
      } finally {
        if (_didIteratorError27) {
          throw _iteratorError27;
        }
      }
    }
  },
  object: function object(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) != "object") {
      throw new Error("You must pass an object to jst.object()");
    }
    return obj.$jst = new JstObject(obj);
  },
  makeGlobal: function makeGlobal(prefix) {
    jst.global = true;
    jst.globalTagPrefix = prefix || jst.tagPrefix;
    var _iteratorNormalCompletion28 = true;
    var _didIteratorError28 = false;
    var _iteratorError28 = undefined;
    try {
      var _loop4 = function _loop4() {
        var tag = _step28.value;
        var name = jst.globalTagPrefix + tag;
        var g = typeof global !== "undefined" ? global : window;
        g[name] = function () {
          return jst[name].apply(this, arguments);
        };
      };
      for (var _iterator28 = (0, _getIterator3.default)(jst.tags), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
        _loop4();
      }
    } catch (err) {
      _didIteratorError28 = true;
      _iteratorError28 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion28 && _iterator28.return) {
          _iterator28.return();
        }
      } finally {
        if (_didIteratorError28) {
          throw _iteratorError28;
        }
      }
    }
  },
  setDebug: function setDebug(val) {
    jst.debug = val;
  },
  _init: function _init() {
    jst.addCustomElements(jst.tags);
    jst.addCssFunctions(jst.cssFuncs);
    jst.addCssUnits(jst.cssUnits);
    jst.styleManager = new JstStyleManager();
    if (typeof window !== "undefined") {
      jst("head").appendChild(jst.styleManager);
    } else {
      global.HTMLElement = function HTMLElement() {
        (0, _classCallCheck3.default)(this, HTMLElement);
      };
    }
  },
  _addCssUnit: function _addCssUnit(unit, val) {
    if (typeof val === "number") {
      return "" + val + (unit || "");
    }
    return val && val.toString ? val.toString() : val;
  },
  _flatten: function _flatten() {
    var flat = [];
    for (var i = 0; i < arguments.length; i++) {
      if (arguments[i] instanceof Array) {
        flat.push.apply(flat, jst._flatten.apply(this, arguments[i]));
      } else if (arguments[i] instanceof Function) {
        var result = arguments[i]();
        if (result instanceof Array) {
          flat.push.apply(flat, jst._flatten.apply(this, result));
        } else {
          flat.push(result);
        }
      } else {
        flat.push(arguments[i]);
      }
    }
    return flat;
  },
  _normalizeCss: function _normalizeCss(input) {
    var flat = jst._flatten(input);
    var evenFlatter = [];
    flat.map(function (entry) {
      if (entry instanceof Object) {
        evenFlatter = evenFlatter.concat(jst._normalizeCssObject(entry));
      } else {
        evenFlatter.push(entry);
      }
    });
    return evenFlatter;
  },
  _normalizeCssObject: function _normalizeCssObject(obj) {
    var _this6 = this;
    var atRules = new _set2.default(["$media", "$keyframes", "$supports", "$page", "$fontFace", "$viewport", "$counterStyle", "$fontFeatureValues", "$swash", "$ornaments", "$stylistic", "$styleset", "$characterVariant"]);
    var fixed = [];
    var _iteratorNormalCompletion29 = true;
    var _didIteratorError29 = false;
    var _iteratorError29 = undefined;
    try {
      var _loop5 = function _loop5() {
        var prop = _step29.value;
        var sel = void 0;
        var fixedSetting = {};
        if (atRules.has(prop)) {
          var processed = _this6._normalizeCssObject(obj[prop]);
          sel = prop.replace(/^\$/, "@").replace(/([A-Z])/g, function (m) {
            return "-" + m.toLowerCase();
          });
          processed.map(function (item) {
            return fixedSetting = (0, _assign2.default)(fixedSetting, item);
          });
        } else {
          var parts = prop.split("$");
          sel = parts.shift();
          var _iteratorNormalCompletion30 = true;
          var _didIteratorError30 = false;
          var _iteratorError30 = undefined;
          try {
            for (var _iterator30 = (0, _getIterator3.default)(parts), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
              var part = _step30.value;
              if (part === "c") {
                sel = "." + sel;
              } else if (part === "i") {
                sel = "#" + sel;
              } else {
                sel = sel + ":" + part;
              }
            }
          } catch (err) {
            _didIteratorError30 = true;
            _iteratorError30 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion30 && _iterator30.return) {
                _iterator30.return();
              }
            } finally {
              if (_didIteratorError30) {
                throw _iteratorError30;
              }
            }
          }
          var setting = jst._flatten(obj[prop]);
          setting.map(function (val) {
            if (val instanceof Object) {
              fixedSetting = (0, _assign2.default)(fixedSetting, jst._normalizeCssStyles(val));
            } else {
              fixedSetting = val;
            }
          });
        }
        var tmpObj = {};
        tmpObj[sel] = fixedSetting;
        fixed.push(tmpObj);
      };
      for (var _iterator29 = (0, _getIterator3.default)((0, _keys2.default)(obj)), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
        _loop5();
      }
    } catch (err) {
      _didIteratorError29 = true;
      _iteratorError29 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion29 && _iterator29.return) {
          _iterator29.return();
        }
      } finally {
        if (_didIteratorError29) {
          throw _iteratorError29;
        }
      }
    }
    return fixed;
  },
  _normalizeCssStyles: function _normalizeCssStyles(obj) {
    var fixed = {};
    var _iteratorNormalCompletion31 = true;
    var _didIteratorError31 = false;
    var _iteratorError31 = undefined;
    try {
      for (var _iterator31 = (0, _getIterator3.default)((0, _keys2.default)(obj)), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
        var _prop2 = _step31.value;
        if (obj[_prop2] instanceof Object && !Array.isArray(obj[_prop2])) {
          var fixedObj = this._normalizeCssStyles(obj[_prop2]);
          fixed[_prop2] = [fixedObj];
        } else {
          (function () {
            var val = jst._flatten(obj[_prop2]);
            var match = _prop2.match(/^([^$]+)\$(.+)/);
            if (match) {
              val = val.map(function (item) {
                return jst._addCssUnit(match[2], item);
              });
              fixed[match[1]] = val;
            } else {
              fixed[_prop2] = val;
            }
          })();
        }
      }
    } catch (err) {
      _didIteratorError31 = true;
      _iteratorError31 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion31 && _iterator31.return) {
          _iterator31.return();
        }
      } finally {
        if (_didIteratorError31) {
          throw _iteratorError31;
        }
      }
    }
    return fixed;
  }
});
jst._init();